import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

//Body
export const ContainerBody = styled.div`
  width: 100% - 48px;
  overflow: hidden;
  padding: 0 24px;
  padding-bottom: 20px;
`;

//List
export const ContainerList = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;
